@let bannerInfo = banner$ | async;
@if (bannerInfo) {
  <div>
    <div class="task-banner-state {{ bannerInfo.cssClass }}">
      <nimbus-user-tp-capacity-button></nimbus-user-tp-capacity-button>
      <span class="task-banner-state-content">
        @if (bannerInfo.text) {
          <span class="state">{{ bannerInfo.text | translate }} </span>
          @if (bannerInfo.subtext) {
            <span class="state">({{ bannerInfo.subtext | translate }}) </span>
          }
          @if (bannerInfo.countDownTo) {
            <span class="time">
              {{ bannerInfo.countDownTo | dateDifference: (currentMoment$ | async) | durationFormat: 'time-in-state' }}
            </span>
          }
          @if (bannerInfo.countUpFrom) {
            <span class="time">
              {{ bannerInfo.countUpFrom | dateDifference: (currentMoment$ | async) | durationFormat: 'time-in-state' }}
            </span>
          }
          @if (bannerInfo.notReadyReason && bannerInfo.notReadyReason !== UserNotReadyReason.None) {
            <nimbus-tooltip [text]="UserNotReadyReasonTooltipMapper[bannerInfo.notReadyReason] | translate"></nimbus-tooltip>
          }
        }
      </span>
      <span class="button-wrapper">
        @if (bannerInfo.allowToExtend) {
          <button nimbusPrimaryIconButton id="btn-extend" [disabled]="isExtendButtonDisabled$ | async" (click)="extend()">
            <i [nimbusIcon]="ICONS.CLOCK_ADD" [iconWeight]="IconWeight.Regular"></i>
            <ng-container>
              <nimbus-tooltip [text]="TranslationKeys.GeneralExtend | translate"></nimbus-tooltip>
            </ng-container>
          </button>
        }
        @if (bannerInfo.allowToStop) {
          <button nimbusPrimaryIconButton id="btn-stop" [disabled]="isStopButtonDisabled$ | async" (click)="stop()">
            <i [nimbusIcon]="ICONS.CLOSE" [iconWeight]="IconWeight.Regular"></i>
            <ng-container>
              <nimbus-tooltip [text]="TranslationKeys.GeneralStop | translate"></nimbus-tooltip>
            </ng-container>
          </button>
        }
      </span>
    </div>
    @if (bannerInfo.countDownTo) {
      <div class="task-banner-progress">
        <div id="task-progress-bar"></div>
      </div>
    }
  </div>
}
